import React, { ReactNode, useState } from 'react';

export interface TailwindTooltipProps {
	reference: ReactNode;
	displayClass: string;
	children: ReactNode;
	position?: 'left' | 'right' | 'top' | 'bottom';
	/** Tailwind width class for the tooltip panel. Defaults to `w-56`. */
	maxWidthClass?: string;
}

export const contentPosition = (type: string) => {
	switch (type) {
		case 'top':
			return 'bottom-full left-1/2 -translate-x-1/2 mb-1.5';
		case 'bottom':
			return 'top-full left-1/2 -translate-x-1/2 mt-1.5';
		case 'left':
			return 'top-1/2 right-full -translate-y-1/2 mr-2.5';
		default:
			return 'top-1/2 left-full -translate-y-1/2 ml-2.5';
	}
};

export const arrowPosition = (type: string) => {
	switch (type) {
		case 'top':
			return 'top-full left-1/2 -translate-x-1/2';
		case 'bottom':
			return 'bottom-full left-1/2 -mb-3 -translate-x-1/2';
		case 'left':
			return 'top-1/2 left-full -ml-1.5';
		default:
			return 'top-1/2 left-0 -ml-1.5';
	}
};

export function TailwindTooltip({
	reference,
	displayClass,
	children,
	position = 'right',
	maxWidthClass = 'w-56',
}: TailwindTooltipProps) {
	const [show, setShow] = useState(false);

	const handleShowTooltip = () => {
		setShow(true);
	};

	const handleHideTooltip = () => {
		setShow(false);
	};

	return (
		<div
			className={`relative cursor-help ${displayClass}`}
			onMouseEnter={handleShowTooltip}
			onMouseLeave={handleHideTooltip}
			onFocus={handleShowTooltip}
			onBlur={handleHideTooltip}
		>
			{reference}
			<div
				className={`absolute ${maxWidthClass} tailwind-tooltip rounded z-50 transition-all ${
					show ? 'opacity-100 visible' : 'opacity-0 hidden'
				} ${contentPosition(position)}`}
			>
				<div
					className={`relative px-2 py-2 rounded text-[12px] leading-snug font-normal not-italic text-black space-y-2 bg-white whitespace-normal normal-case z-10 ${
						position == 'top' ? 'text-center' : 'text-left'
					}`}
				>
					{children}
				</div>
				<i
					className={`absolute -translate-y-1/2 w-3 h-3 rounded-sm rotate-45 bg-white shadow-md origin-center ${arrowPosition(
						position
					)}`}
				></i>
			</div>
		</div>
	);
}
